```vue
<template>
  <section class="evento-lux">

    <!-- ===== CARD 1: CELEBRATION ===== -->
    <article ref="card1" class="card" aria-label="Celebration">
      <img class="icono" src="@/assets/9.avif" alt="" />

      <h3 class="titulo-script">Celebration</h3>

      <p class="hora">6:00 PM</p>

      <p class="lugar">
        Factory of Dreams
      </p>

      <!-- 🔥 CHROME CIRCULAR PHOTO -->
      <div class="contenedor-foto-perfil">
        <div class="borde-cromado">
          <!-- Replace this URL with the actual photo, e.g., "@/assets/couple.jpg" -->
          <img src="@/assets/Gemini_Generated_Image_delladdelladdell.png" alt="Couple" class="foto-perfil" />
        </div>
      </div>

      <p class="direccion">
       261 3rd Ave<br>
       Chula Vista, California.
      </p>

      <a
        ref="btn1"
        class="btn-rosa"
        href="https://maps.app.goo.gl/Hwv5fCqdPw8mCfwt5"
        target="_blank"
        rel="noopener"
      >
        Get Directions
        <span class="sheen"></span>
      </a>
    </article>

    <!-- 🔥 NEW NOTE -->
   
    <br><br>
  </section>
</template>


<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',

  setup() {

    const card1 = ref(null)
    const btn1 = ref(null)

    const animCard = (cardEl, btnEl) => {

      const $ = gsap.utils.selector(cardEl)

      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const foto   = $('.contenedor-foto-perfil') // Ref nueva foto
      const dir    = $('.direccion')
      const nota   = $('.ceremonia-nota')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, {
        opacity: 0,
        y: 40,
        duration: 0.6
      })

      .from(icono, {
        opacity: 0,
        y: 20,
        scale: 0.7,
        rotation: -12,
        duration: 0.6,
        ease: 'back.out(1.7)'
      }, '-=0.3')

      .from(titulo, {
        opacity: 0,
        y: 20,
        duration: 0.5
      }, '-=0.3')

      .from(hora, {
        opacity: 0,
        x: -20,
        duration: 0.4
      }, '-=0.3')

      .from(lugar, {
        opacity: 0,
        x: 20,
        duration: 0.4
      }, '-=0.4')

      /* 🔥 ANIMACIÓN ENTRADA FOTO */
      .from(foto, {
        opacity: 0,
        scale: 0,
        rotation: 180,
        duration: 0.8,
        ease: 'back.out(1.5)'
      }, '-=0.3')

      .from(dir, {
        opacity: 0,
        y: 20,
        duration: 0.4
      }, '-=0.3')

      /* 🔥 NOTA BONITA */
      .from(nota, {
        opacity: 0,
        y: 25,
        scale: 0.9,
        duration: 0.7,
        ease: 'back.out(1.7)'
      }, '-=0.2')

      .from(btnEl, {
        opacity: 0,
        scale: 0.95,
        duration: 0.4
      }, '-=0.3')

      // brillo botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,

        onEnter: () => {

          const shine = btnEl.querySelector('.sheen')

          if (!shine) return

          gsap.fromTo(
            shine,
            {
              xPercent: -120,
              opacity: 0
            },
            {
              xPercent: 140,
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out'
            }
          )

          /* 🔥 LATIDO NOTA */
          gsap.to(nota, {
            scale: 1.02,
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })
        }
      })
    }

    onMounted(() => {
      animCard(card1.value, btn1.value)
    })

    return {
      card1,
      btn1
    }
  }
}
</script>

<style scoped>

/* ==================== BASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 100%;
  padding: 28px 18px 4px;

  background:
    radial-gradient(
      1200px 600px at 50% -10%,
      rgba(255,255,255,.92),
      rgba(255,255,255,.98)
    ),

    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.6" fill="%23f1f1f1"/></svg>') repeat;

  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);

  border: 1px solid var(--borde);
  border-radius: 18px;

  padding: 24px 20px 28px;

  text-align: center;
}

/* Icono discreto */
.icono{
  width: 52px;
  height:auto;

  display:block;
  margin: 0 auto 10px;

  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));

  opacity: .92;
}

/* Tipos */
.titulo-script {
  font-family: 'britishgruesa', cursive;
  font-weight: 900;
  font-size: 65px;
  letter-spacing: .4px;
  margin: 4px 0 8px;

  /* 🔥 EFECTO DORADO CROMADO CON TEXT-CLIP */
  background: linear-gradient(
    110deg,
    #bf953f 0%,
    #fcf6ba 25%,
    #b38728 50%,
    #fbf5b7 75%,
    #aa771c 100%
  );
  background-size: 200% auto;
  
  /* Aplica el degradado directamente sobre las letras */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;

  /* 🔥 ANIMACIÓN SUAVE Y OPTIMIZADA */
  animation: brilloDorado 4s linear infinite;

  /* Sombra sutil de fondo para darle profundidad sin opacar el brillo */
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}

/* 🔥 KEYFRAMES PARA EL MOVIMIENTO DEL BRILLO */
@keyframes brilloDorado {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}

.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}

/* 🔥 ESTILOS FOTO CROMADA */
.contenedor-foto-perfil {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px 0 20px;
  /* Perspectiva para la animación GSAP */
  perspective: 1000px; 
}

.borde-cromado {
  width: 190px !important;
  height: 190px !important;
  border-radius: 50%;
  padding: 3px; /* Grosor del borde */
  position: relative;
  
  /* Fondo base dorado */
  background: #b8860b; 
  
  /* Degradado Cromo Dorado Complejo */
  background: linear-gradient(
    135deg,
    #ffecb3 0%,   /* Oro claro */
    #b8860b 25%,  /* Oro oscuro */
    #fff9e6 50%,  /* Brillo máximo blanco/oro */
    #aa7700 75%,  /* Sombra oro */
    #ffecb3 100%  /* Oro claro */
  );
  
  /* Animación CSS infinita para el efecto metalizado en los bordes */
  background-size: 400% 400%;
  animation: gradienteCromo 5s ease infinite;
  
  /* Sombras para dar volumen y despegar de la tarjeta */
  box-shadow: 
    0 4px 15px rgba(0,0,0,0.2),
    inset 0 0 5px rgba(255,255,255,0.5);
    
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Mantiene la foto circular */
}

/* Keyframes para el movimiento del brillo cromado */
@keyframes gradienteCromo {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Efecto de brillo overlay (Opcional, añade un destello extra) */
.borde-cromado::after {
  content: '';
  position: absolute;
  top: -50%; left: -50%;
  width: 200%; height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 60%);
  border-radius: 50%;
  opacity: 0.5;
  transform: rotate(30deg);
  pointer-events: none;
}

.foto-perfil {
  width: 180%;
  height: 180%;
  object-fit: cover;
  border-radius: 50%;
  /* Pequeño borde interno para separar de la zona cromada */
  border: 2px solid white; 
  display: block;
  z-index: 1; /* Por encima del pseudo-elemento ::after */
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 17px !important;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* 🔥 NOTA */
.ceremonia-nota{

  font-family:'padres', serif;

  font-size:17px;
  line-height:1.7;

  color:#383636;

  max-width:88%;

  margin:14px auto 18px;

  font-style:italic;
  letter-spacing:.03em;

  padding:12px 16px;

  border-radius:16px;

  background:
    linear-gradient(
      135deg,
      rgba(150, 75, 125, 0.18),
      rgba(224, 133, 183, 0.75)
    );

  border:1px solid rgba(245,201,230,.5);

  box-shadow:
    0 6px 16px rgba(0,0,0,.05);
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  padding: 11px 20px;

  border-radius: 14px;

  background: #f5c9e6;

  color: #1f1f1f;

  text-decoration: none;

  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;

  box-shadow:
    0 8px 16px rgba(0,0,0,.12),
    inset 0 1px 0 rgba(255,255,255,.7);

  transition:
    transform .16s ease,
    box-shadow .16s ease,
    filter .16s ease;

  border: 1px solid rgba(0,0,0,.06);

  z-index: 0;
}

.btn-rosa:hover{
  transform: translateY(-1px);

  box-shadow:
    0 12px 20px rgba(0,0,0,.16),
    inset 0 1px 0 rgba(255,255,255,.8);

  filter: brightness(1.03);
}

.btn-rosa .sheen{
  position: absolute;

  top: -30%;
  left: -30%;

  width: 60%;
  height: 160%;

  transform: rotate(20deg);

  background:
    linear-gradient(
      90deg,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,.55) 50%,
      rgba(255,255,255,0) 100%
    );

  pointer-events: none;

  mix-blend-mode: screen;

  opacity: 0;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){

  .hora{
    font-size: 22px;
  }

  .lugar{
    font-size: 16px;
  }
  
  /* Ajuste tamaño foto en móviles muy pequeños */
  .borde-cromado {
    width: 190px;
    height: 190px;
  }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){

  *{
    transition: none !important;
    animation: none !important;
  }
}

</style>

```